@let popupTitle = "popupTitle" | t;
@let closeButtonText = "closeButton" | t;

<button class="btn btn-cerrix" (click)="openPopup(popupTitle, closeButtonText)">
    <i class="fas fa-pencil"></i>
    <span>{{ "editButton" | t }}</span>
</button>

<ng-template #editorTemplate>
    <div class="cerrix-editor-in-popup">
        <cerrix-editor
            [value]="loadedValue"
            (valueChange)="valueChange.emit($event)"
        ></cerrix-editor>
    </div>
</ng-template>
